<template>
  <el-dropdown trigger="click" @command="switchLang" class="lang-switch">
    <span class="lang-btn">
      <i class="el-icon-s-flag"></i>
      <span class="lang-label">{{ currentLabel }}</span>
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="zh" :class="{ 'is-active': $i18n.locale === 'zh' }">
        🇨🇳 中文
      </el-dropdown-item>
      <el-dropdown-item command="en" :class="{ 'is-active': $i18n.locale === 'en' }">
        🇺🇸 English
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'LangSwitch',
  computed: {
    currentLabel() {
      return this.$i18n.locale === 'zh' ? '中文' : 'EN';
    }
  },
  methods: {
    switchLang(lang) {
      if (this.$i18n.locale === lang) return;
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
    }
  }
};
</script>

<style scoped>
.lang-switch {
  margin-right: 16px;
}
.lang-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 20px;
  transition: all 0.3s;
  color: #595959;
  font-size: 14px;
}
.lang-btn:hover {
  background: rgba(24, 144, 255, 0.08);
  color: #1890ff;
}
.lang-label {
  margin: 0 4px;
  font-weight: 500;
}
.el-icon--right {
  font-size: 12px;
}
</style>
